// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"529e5907","419":"893f9b64"}[chunkId] + ".chunk.css";
};